<template>
  <div class="w-full max-h-[476px] overflow-auto">
    <div class="inline-block min-w-max">
      <div class="flex flex-col items-center justify-center mr-[-4px]">
        <div
          @click="() => info('1')"
          class="w-[250px] h-[58px] p-[4px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
        >
          <div class="w-[50px] h-[50px]">
            <img v-if="img.image" :src="img.image" alt="" />
            <img v-else src="../../assets/images/user-default.png" alt="" />
          </div>
          <span class="PC_caption-SB"> ผู้บัญชาการ/ผู้อำนวยการ </span>
        </div>
        <div class="w-[2px] h-[30px] bg-[#9B237B]"></div>
      </div>

      <div class="flex items-start justify-center mr-[-4px]">
        <div class="flex items-center">
          <div
            @click="() => info('2')"
            class="w-[200px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
          >
            <span class="PC_caption-SB"> ศูนย์ข้อมูลประชาสัมพันธ์ร่วม </span>
          </div>
          <div class="w-[30px] h-[2px] bg-[#9B237B]"></div>
        </div>
        <div class="w-[2px] h-[143px] bg-[#9B237B]"></div>
        <div class="h-[143px] flex flex-col gap-[30px]">
          <div class="flex items-center">
            <div class="w-[30px] h-[2px] bg-[#9B237B]"></div>
            <div
              @click="() => info('3')"
              class="w-[200px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
            >
              <span class="PC_caption-SB"> ที่ปรึกษา/ผู้เชี่ยวชาญ </span>
            </div>
          </div>
          <div class="flex items-center">
            <div class="w-[30px] h-[2px] bg-[#9B237B]"></div>
            <div
              @click="() => info('4')"
              class="w-[200px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
            >
              <span class="PC_caption-SB"> ศูนย์ประสานการปฎิบัติการ </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-start">
        <!-- left -->
        <div class="flex flex-col items-center">
          <div class="w-full flex justify-end">
            <div class="w-[181px] h-[2px] bg-[#9B237B]"></div>
          </div>
          <div class="w-[2px] h-[18px] bg-[#9B237B]"></div>
          <div
            class="w-[190px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FBEFF8]"
          >
            <span class="PC_caption-SB">ส่วนปฎิบัติการ</span>
          </div>
          <div class="w-[2px] h-[20px] bg-[#9B237B]"></div>
          <div class="w-full flex items-start justify-end">
            <!-- left -->
            <div class="flex flex-col items-end gap-[20px]">
              <div class="flex items-center">
                <div
                  @click="() => info('6')"
                  class="w-[101px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB"> สปฉ.1 คมนาคม </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
              <div class="flex items-center">
                <div
                  @click="() => info('9')"
                  class="w-[128px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB"> สปฉ.4 ผจญเพลิง </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
              <div class="flex items-center">
                <div
                  @click="() => info('14')"
                  class="w-[160px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB text-nowrap">
                    สปฉ.9 การค้นหา และกู้ภัย
                  </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
            </div>
            <!-- left -->
            <!-- center -->
            <div class="w-[2px] h-[208px] bg-[#9B237B]"></div>
            <!-- center -->
            <!-- right -->
            <div class="flex flex-col gap-[20px]">
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('12')"
                  class="w-[160px] h-[74px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.7 <br />
                    การสนับสนุนทรัพยากร <br />
                    ทางทหาร
                  </span>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('13')"
                  class="w-[160px] h-[56px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.8 การแพทย์ <br />
                    และสาธารณสุข
                  </span>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('15')"
                  class="w-[160px] h-[74px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.10 สารเคมี <br />
                    วัตถุอันตราย <br />
                    และกัมมันตรังสี
                  </span>
                </div>
              </div>
            </div>
            <!-- right -->
          </div>
        </div>
        <!-- left -->

        <div class="w-[10px] h-[2px] bg-[#9B237B]"></div>
        <!-- center -->
        <div class="w-[324px] flex flex-col items-center">
          <div class="w-full h-[2px] bg-[#9B237B]"></div>
          <div class="w-[2px] h-[20px] bg-[#9B237B] ml-[-16px]"></div>
          <div
            class="w-[190px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FBEFF8]"
          >
            <span class="PC_caption-SB">ส่วนอำนวยการ</span>
          </div>
          <div class="w-[2px] h-[20px] bg-[#9B237B] ml-[-16px]"></div>
          <div class="flex items-center">
            <!-- left -->
            <div class="flex items-center">
              <div
                @click="() => info('19')"
                class="w-[134px] h-[38px] p-[10px] px-[4px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
              >
                <span class="PC_caption-SB"> สปฉ.15 การต่างประเทศ </span>
              </div>
              <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
            </div>
            <!-- left -->
            <!-- center -->
            <div class="w-[2px] h-[56px] bg-[#9B237B]"></div>
            <!-- center -->
            <!-- right -->
            <div class="flex items-center">
              <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              <div
                @click="() => info('10')"
                class="w-[150px] h-[56px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
              >
                <span class="PC_caption-SB !text-left">
                  สปฉ.5 การจัดการในภาวะ <br />
                  ฉุกเฉิน
                </span>
              </div>
            </div>
            <!-- right -->
          </div>
          <div class="flex flex-col items-center justify-center ml-[-16px]">
            <div class="w-[2px] h-[34px] bg-[#9B237B]"></div>
            <div
              @click="() => info('5')"
              class="w-[134px] h-[38px] p-[10px] px-[4px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
            >
              <span class="PC_caption-SB"> กฎหมาย </span>
            </div>
          </div>
        </div>
        <!-- center -->
        <div class="w-[10px] h-[2px] bg-[#9B237B]"></div>

        <!-- right -->
        <div class="flex flex-col items-center">
          <div class="w-full flex justify-start">
            <div class="w-[171px] h-[2px] bg-[#9B237B]"></div>
          </div>
          <div class="w-[2px] h-[18px] bg-[#9B237B]"></div>
          <div
            class="w-[190px] h-[38px] p-[10px] flex items-center justify-center gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FBEFF8]"
          >
            <span class="PC_caption-SB">ส่วนปฎิบัติการ</span>
          </div>
          <div class="w-[2px] h-[20px] bg-[#9B237B]"></div>
          <div class="flex items-start">
            <!-- left -->
            <div class="flex flex-col gap-[20px]">
              <div class="flex items-center">
                <div
                  @click="() => info('7')"
                  class="w-[150px] h-[74px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.2 <br />
                    เทคโนโลยีสารสนเทศ <br />
                    และการสื่อสาร
                  </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
              <div class="flex items-center">
                <div
                  @click="() => info('8')"
                  class="w-[150px] h-[56px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.3 สาธารณูปโภค <br />และโครงสร้างพื้นฐาน
                  </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
              <div class="flex items-center">
                <div
                  @click="() => info('16')"
                  class="w-[150px] h-[38px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.11 การเกษตร
                  </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
              <div class="flex items-center">
                <div
                  @click="() => info('11')"
                  class="w-[150px] h-[56px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.6 สวัสดิการสังคม <br />และความมั่นคงของมนุษย์
                  </span>
                </div>
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
              </div>
            </div>
            <!-- left -->
            <!-- center -->
            <div class="w-[2px] h-[257px] bg-[#9B237B]"></div>
            <!-- center -->
            <!-- right -->
            <div class="flex flex-col gap-[20px]">
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('18')"
                  class="w-[150px] h-[56px] p-[10px] pr-[4px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.14 การฟื้นฟูเศรษฐกิจ <br />
                    การศึกษา และวัฒนธรรม
                  </span>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('17')"
                  class="w-[150px] h-[38px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left"> สปฉ.12 พลังงาน </span>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('20')"
                  class="w-[150px] h-[74px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.17 <br />
                    ทรัพยากรธรรมชาติ <br />
                    และสิ่งแวดล้อม
                  </span>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-[19px] h-[2px] bg-[#9B237B]"></div>
                <div
                  @click="() => info('21')"
                  class="w-[150px] h-[56px] p-[10px] flex items-center justify-start gap-[10px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF] cursor-pointer"
                >
                  <span class="PC_caption-SB !text-left">
                    สปฉ.18 งบประมาณ <br />
                    และการบริจาค
                  </span>
                </div>
              </div>
            </div>
            <!-- right -->
          </div>
        </div>
        <!-- right -->
      </div>
    </div>
  </div>
</template>


<script setup>
const props = defineProps({
  img: {
    type: String,
    default: "",
  },
});

const choice = [
  {
    id: 1,
    name: "ผู้บัญชาการ/ผู้อำนวยการ",
  },
  {
    id: 2,
    name: "ศูนย์ข้อมูลประชาสัมพันธ์ร่วม",
  },
  {
    id: 3,
    name: "ที่ปรึกษา/ผู้เชี่ยวชาญ",
  },
  {
    id: 4,
    name: "ศูนย์ประสานการปฎิบัติการ",
  },
  {
    id: 5,
    name: "กฎหมาย",
  },
  {
    id: 6,
    name: "สปฉ.1 คมนาคม",
  },
  {
    id: 7,
    name: "สปฉ.2 เทคโนโลยีสารสนเทศ และการสื่อสาร",
  },
  {
    id: 8,
    name: "สปฉ.3 สาธารณูปโภค และโครงสร้างพื้นฐาน",
  },
  {
    id: 9,
    name: "สปฉ.4 ผจญเพลิง",
  },
  {
    id: 10,
    name: "สปฉ.5 การจัดการในภาวะ ฉุกเฉิน",
  },
  {
    id: 11,
    name: "สปฉ.6 สวัสดิการสังคม และความมั่นคงของมนุษย์",
  },
  {
    id: 12,
    name: "สปฉ.7 การสนับสนุนทรัพยากรทางทหาร",
  },
  {
    id: 13,
    name: "สปฉ.8 การแพทย์ และสาธารณสุข",
  },
  {
    id: 14,
    name: "สปฉ.9 การค้นหา และกู้ภัย",
  },
  {
    id: 15,
    name: "สปฉ.10 สารเคมี วัตถุอันตราย และกัมมันตรังสี",
  },
  {
    id: 16,
    name: "สปฉ.11 การเกษตร",
  },
  {
    id: 17,
    name: "สปฉ.12 พลังงาน",
  },
  {
    id: 18,
    name: "สปฉ.14 การฟื้นฟูเศรษฐกิจ การศึกษา และวัฒนธรรม",
  },
  {
    id: 19,
    name: "สปฉ.15 การต่างประเทศ",
  },
  {
    id: 20,
    name: "สปฉ.17 ทรัพยากรธรรมชาติ และสิ่งแวดล้อม",
  },
  {
    id: 21,
    name: "สปฉ.18 งบประมาณ และการบริจาค",
  },
];

const emit = defineEmits(["clicked"]);

const getNameById = (id) => {
  const item = choice.find((c) => c.id === Number(id));
  return item ? item.name : null;
};

const info = (id) => {
  const name = getNameById(id);
  if (id === "1") {
    emit("clicked", id, name);
  } else if (id != "1") {
    emit("clicked", id, name);
  }
};
</script>

<style lang="scss" scoped>
.PC_caption-SB {
  color: var(--grey-950, #1f1d1f);
  text-align: center;
  /* PC font/PC_caption-SB */
  font-family: Kanit;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 150% */
}
</style>
